import { useResourcesEntries } from "../../../../hooks/useResourcesEntries"
import { ResourcesCard } from "./ResourcesCard"

export const LatestResources = () => {
  const resources = useResourcesEntries().slice(0, 3)

  return <ResourcesCard resources={resources} />
}
